import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Province } from './province.model';

const axios = useAxios();

export interface ProvinceService {
  Fetch: () => Promise<AxiosResponse<Province[]>>;
}

const Fetch = (): Promise<AxiosResponse<Province[]>> =>
  axios.Get<Province[]>('/api/provinces');

export default { Fetch } as ProvinceService;
